const BASE_URL = "https://alicepare.api.ayatasgroup.com/";

export const LOGIN_URL = BASE_URL + "login";
export const LOGOUT_URL = BASE_URL + "logout";
export const DASHBOARD_URL = BASE_URL + "dashboard";
export const LEAD_LIST = BASE_URL + "agentlist";
export const ADD_LEAD = BASE_URL + "saveclient/";
export const LEAD_DETAILS = BASE_URL + "getclient/";
export const DELETE_LEAD = BASE_URL + "deleteclient";
export const ZOOM_CALLS_LIST = BASE_URL + "zoomlist";
export const ZOOM_CRON_URL = BASE_URL + "zoomcron";
export const TEAM_LIST = BASE_URL + "users";
export const MATTERS_LIST = BASE_URL + "matters";
export const ADD_MATTER = BASE_URL + "savematter/";
export const MATTER_DETAILS = BASE_URL + "getmatter/";
export const DELETE_MATTER = BASE_URL + "deletematter/";
export const MATTER_STATUS = BASE_URL + "matters_status";
export const SOURCE_LIST = BASE_URL + "sources";

export const CREATE_TEAM = BASE_URL + "users/";

// export const ZOOM_CALLS_URL = {
//   data: [
//     {
//       id: "1",
//       direction: "Inbound",
//       from: "(408) Shovanne Wilson",
//       to: "(307) jane test AR Ext:1107985",
//       start_time: "Aug 11 2025 at 9:44:55 PM",
//       event: "Incoming",
//       call_result: "Answered",
//       recorded: "y",
//       duration: "00:00:45",
//       site: "Main",
//     },
//     {
//       id: "2",
//       direction: "Inbound",
//       from: "(415) Kenny Battle",
//       to: "(307) jane test AR Ext:1107985",
//       start_time: "Aug 01 2025 at 9:44:55 PM",
//       event: "Incoming",
//       call_result: "Answered",
//       recorded: "y",
//       duration: "00:01:45",
//       site: "Main",
//     },
//     {
//       id: "2",
//       direction: "Inbound",
//       from: "(396) Joseph Sherrick",
//       to: "(307) jane test AR Ext:1107985",
//       start_time: "Aug 04 2025 at 9:44:55 PM",
//       event: "Incoming",
//       call_result: "Answered",
//       recorded: "y",
//       duration: "00:01:00",
//       site: "Main",
//     },
//     {
//       id: "2",
//       direction: "Inbound",
//       from: "(401) Serena Tiell",
//       to: "(307) jane test AR Ext:1107985",
//       start_time: "Aug 08 2025 at 9:44:55 PM",
//       event: "Incoming",
//       call_result: "Answered",
//       recorded: "y",
//       duration: "00:01:05",
//       site: "Main",
//     },
//     {
//       id: "2",
//       direction: "Inbound",
//       from: "(409) Aqila Kermani",
//       to: "(307) jane test AR Ext:1107985",
//       start_time: "Aug 05 2025 at 9:44:55 PM",
//       event: "Incoming",
//       call_result: "Answered",
//       recorded: "y",
//       duration: "00:01:15",
//       site: "Main",
//     },
//   ],
// };
